import React from 'react'
import * as styles from './index.module.css'
import Video from '../Video'

const OusterInAction = (props) => {
  const { nodeLocale, video_ref } = props
  const videoId = video_ref && video_ref.videoId
  const videoPlaylistId = video_ref && video_ref.videoPlaylistId
  const videoUrl = video_ref && video_ref.videoUrl
  const videoBackgroundImage = video_ref && video_ref.backgroundImage
  const videoAutoplay = video_ref && video_ref.autoplay
  const videoOpts = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      list: videoPlaylistId,
      modestbranding: 1,
      autoplay: videoAutoplay ? 1 : 0,
      rel: 0,
    },
  }
  return (
    <div className={styles.blackContainer}>
      <div className="wrapper">
        <div className={styles.container}>
          <div className={styles.section}>
            <h2 className={styles.title}>{props.title}</h2>
            <ul className={styles.list}>
              {props.components[0].sentenceList.map((sentence, idx) => (
                <li className={styles.listItem} key={idx}>
                  {sentence}
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.section}>
            <div className={styles.videoPreview}>
              <Video
                videoId={videoId}
                videoOpts={videoOpts}
                videoUrl={videoUrl}
                videoBackgroundImage={videoBackgroundImage}
                nodeLocale={nodeLocale}
              />
            </div>
            <div className={styles.videoDescription}>
              {props.components[1].subtitle.subtitle}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OusterInAction
